
<div class="row">
    <div class="col-sm-offset-2 col-md-offset-3 col-xs-12 col-sm-8 col-md-6">
        <br /><br/>
        <sync-error [errcode]="errcode"></sync-error>
        <div class="panel panel-default">
            <form [formGroup]="linkPass" (submit)="linkPass.valid && setPassword()" method="POST" autocomplete="off" ngNativeValidate>

            <div class="panel-heading">
                <h3 class="panel-title"><i class="fas fa-lock"></i> Enter password</h3>
            </div>
            <div class="panel-body">
                <p>This link is password protected. If you do not have a password you'll need to contact the person who sent you the link.</p>
                <div class="form-group">
                    <input
                        autocomplete="off"
                        type="password"
                        class="form-control"
                        id="link-consume-passwordfield"
                        formControlName="passwordfield"
                        syncShowHidePassword
                        identity="linkconsumepass"
                    />
                </div>
        
            </div>
            <div class="panel-footer text-right">
                <button
                    [disabled]="!linkPass.valid || spinner"
                    type="submit"
                    class="btn btn-primary"
                    *ngIf="!buttonPrimaryColor"
                >
                    <i class="fa fa-spin fa-spinner" *ngIf="spinner"></i>
                    Submit
                </button>
                <!-- custom white label -->
                <button
                    [disabled]="!linkPass.valid || spinner"
                    type="submit"
                    class="btn"
                    [style.background-color]="buttonPrimaryColor"
                    [style.border-color]="buttonPrimaryColor"
                    [style.color]="buttonTextColor"
                    *ngIf="buttonPrimaryColor"
                >
                    <i class="fa fa-spin fa-spinner" *ngIf="spinner"></i>
                    Submit
                </button>
            </div>
        </form>
    </div>
    </div>
</div> 